import script from "./summaryB.vue?vue&type=script&setup=true&lang=js"
export * from "./summaryB.vue?vue&type=script&setup=true&lang=js"

import "./summaryB.vue?vue&type=style&index=0&id=8b9ac136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b9ac136"]])

export default __exports__